import { db } from "./connect";
import axios from "axios";
import firestore, {
  collection,
  onSnapshot,
  query,
  where,
  arrayUnion,
  arrayRemove,
  updateDoc,
  doc,
} from "firebase/firestore";
import IChatModel, {
  IChatConversationModel,
  IChatlastMessage,
  IChatOwnersData,
} from "./models/chat";
import enviroment from "../enviroment";
import StorageService from "./storage";

const storageService = new StorageService();

class ChatsService {
  collectionName = "chats";

  getRealTime(func: any): any {
    const collRef = collection(db, this.collectionName);
    const filter = query(collRef, where("status", "<", 2));

    onSnapshot(filter, func);
  }

  async sendMessage(
    id = "",
    conversation: IChatConversationModel
  ): Promise<string> {
    try {
      const docRef = doc(db, this.collectionName, id);
      await updateDoc(docRef, { 
        conversation: arrayUnion(conversation),
        lastMessage: { uid: conversation.ownerId, read: false }
       });
      return "OK";
    } catch (err) {
      console.log(err);
      return chatErrors.systemError;
    }
  }

  updateLastMessage(id = "", uid: string): Promise<string> {
    return (async (): Promise<string> => {
      try {
        if (!id || !uid) {
          return chatErrors.emptyFills;
        }

        const docRef = doc(db, this.collectionName, id);
        await updateDoc(docRef, {
          lastMessage: { uid, read: false },
        });
        return "OK";
      } catch (err) {
        console.log(err);
        return chatErrors.systemError;
      }
    })();
  }

  async readLastMessage(
    id = "",
    lastMessage: IChatlastMessage
  ): Promise<string> {
    try {
      if (!id || !lastMessage) {
        return chatErrors.emptyFills;
      }

      const docRef = doc(db, this.collectionName, id);
      await updateDoc(docRef, {
        lastMessage: { uid: lastMessage.uid, read: true },
      });
      return "OK";
    } catch (err) {
      console.log(err);
      return chatErrors.systemError;
    }
  }

  takeChat(id = "", user: IChatOwnersData): Promise<string> {
    return (async (): Promise<string> => {
      try {
        if (!id || !user) {
          return chatErrors.emptyFills;
        }
        const docRef = doc(db, this.collectionName, id);
        await updateDoc(docRef, {
          ownersId: arrayUnion(user.uid),
          ownersData: arrayUnion(user),
          status: 1,
        });
        return "OK";
      } catch (err) {
        console.log(err);
        return chatErrors.systemError;
      }
    })();
  }

  dropOut(uid = "", chat: IChatModel, admin = false): Promise<string> {
    return (async (): Promise<string> => {
      try {
        if (!uid || !chat) {
          return chatErrors.emptyFills;
        }
        const ownerData = chat.ownersData.find(
          (ownerData) => ownerData.uid === uid
        );
        // console.log("ok", ownerData);
        if (!ownerData && !admin) {
          return chatErrors.deniedAction;
        }

        const docRef = doc(db, this.collectionName, chat.id);
        await updateDoc(docRef, {
          ownersId: arrayRemove(uid),
          ownersData: arrayRemove(ownerData),
          status: 0,
          picture: "",
        });
        return "OK";
      } catch (err) {
        console.log(err);
        return chatErrors.systemError;
      }
    })();
  }

  sendPushNotification(uid: string, title: string, body: any, data: any): any {
    (async () => {
      try {
        const end = `${enviroment.cloudFunctions}/sendPushNotification`;
        await axios.post(end, {
          uid,
          title,
          data,
          body,
        });
        return "OK";
      } catch (err) {
        console.log(err);
      }
    })();
  }

  async uploadImageAndVideo(
    url: string,
    type: "image" | "video" | undefined,
    isString = false
  ) {
    if (type === "image" && !isString) {
      return await storageService.uploadImage(url);
    }
    // if (type === "image" && isString) {
		// return await storageService.uploadImageString(url);
    // }
    // if(type === "video"){ return await storageService.uploadVideo(url); }
    return "";
  }

  async uploadStringImage(value: string, ext: string){
    return storageService.uploadImageString(value, ext);
  }

  updatePicture(id: string, picture: string, isEmpty = false): Promise<string> {
    return (async (): Promise<string> => {
      try {
        if (!id || (!picture && !isEmpty)) {
          return chatErrors.emptyFills;
        }

        const docRef = doc(db, this.collectionName, id);
        await updateDoc(docRef, { picture });
        return "OK";
      } catch (err) {
        console.log(err);
        return chatErrors.systemError;
      }
    })();
  }

  finishChat(
    uid: string,
    chat: IChatModel,
    status: 0 | 1 | 2,
    isAdmin = false
  ): Promise<string> {
    return (async () => {
      try {
        if (!chat.id || !status) {
          return chatErrors.emptyFills;
        }

        if (!chat.ownersId.includes(uid) && !isAdmin) {
          return chatErrors.deniedAction;
        }

        return await this.updateChatStatus(chat.id, status);
      } catch (err) {
        console.log(err);
        return chatErrors.systemError;
      }
    })();
  }

  async updateChatStatus(id: string, status: 0 | 1 | 2): Promise<string> {
    try {
      const docRef = doc(db, this.collectionName, id);
      await updateDoc(docRef, { status });
      return "OK";
    } catch (err) {
      console.log(err);
      return chatErrors.systemError;
    }
  }
}

const chatErrors = {
  emptyFills: "empty fills",
  noData: "string",
  noId: "invalid or null id",
  noMessage: "no message",
  systemError: "system error",
  deniedAction: "action denied",
};

export default ChatsService;
export { chatErrors };
